export default "__VITE_ASSET__BtzqdCG6__"